module.exports = __webpack_public_path__ + "NeueFrutigerWorld-Black.367397519cb68e1cbeda.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/assets/fonts/neue-frutiger-world/NeueFrutigerWorld-Black.ttf
// module id = ../../../../../src/assets/fonts/neue-frutiger-world/NeueFrutigerWorld-Black.ttf
// module chunks = styles